import { makeStyles, shorthands } from '@fluentui/react-components';

import { ResponsiveSize, isSizeInList } from '@bingads-webui-campaign-react/pmax-overview-responsive-utils';

export const useCampaignStatusSummaryCardsStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    ...shorthands.padding('6px'),
    ...shorthands.gap('12px'),
  },
  fullWidthCards: {
    flexDirection: 'column',
  },
});

export const shouldUseFullWidthCards = (responsiveSize: ResponsiveSize) => !isSizeInList(responsiveSize, ['xl', 'xxl']);
